import { ShieldCheck, AlertTriangle, Info } from "lucide-react";

/**
 * SafeSpendMock — focuses ONLY on the "Seguro de usar / Riesgo
 * mensual" KPI. iter-211.2 — replaces the full-screen dashboard
 * screenshot per user feedback ("solo mostrar el riesgo mensual").
 *
 * Numbers are developer-flavoured: a freelance SaaS dev with
 * incoming Stripe + GitLab revenue and recurring infra costs.
 */
export function SafeSpendMock() {
  return (
    <div
      className="rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50/70 via-white to-amber-50/40 overflow-hidden shadow-sm"
      data-testid="mock-safe-spend"
    >
      {/* Header strip */}
      <div className="px-5 pt-5 pb-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0">
            <ShieldCheck className="h-4 w-4" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-emerald-700">
              Límite seguro · Esta semana
            </div>
            <div className="text-[11px] text-slate-500 leading-tight mt-0.5">
              Calculado en vivo con tus gastos y cobros próximos
            </div>
          </div>
        </div>
        <Info className="h-3.5 w-3.5 text-emerald-700/70" />
      </div>

      {/* Hero number */}
      <div className="px-5 pt-2 pb-4">
        <div
          className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tabular-nums leading-none"
          data-testid="safe-spend-amount"
        >
          $ 1.250.000
          <span className="text-base text-slate-500 ml-1.5 font-semibold">COP</span>
        </div>
        <div className="text-[11px] text-slate-500 mt-2 leading-relaxed">
          Después de cubrir hosting, suscripciones SaaS y la cuota de tu
          tarjeta — todo lo que ya tienes agendado en Pagos.
        </div>
      </div>

      {/* Risk strip */}
      <div className="border-t border-emerald-100 bg-amber-50/60 px-5 py-3 flex items-center gap-3">
        <AlertTriangle className="h-4 w-4 text-amber-700 flex-shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-wider font-semibold text-amber-800">
            Riesgo del mes
          </div>
          <div className="text-sm font-bold text-amber-900 tabular-nums leading-tight mt-0.5">
            Si nada cobra: agotas la reserva el <span className="underline decoration-amber-400 decoration-2 underline-offset-2">día 23</span>
          </div>
        </div>
        <div className="text-right flex-shrink-0">
          <div className="text-[10px] uppercase tracking-wider font-semibold text-amber-800">
            Buffer faltante
          </div>
          <div className="text-sm font-bold tabular-nums text-amber-900 leading-tight">
            $ 3.180.000
          </div>
        </div>
      </div>
    </div>
  );
}
